import clsx from 'clsx';

import styles from './styles.module.scss';

type ButtonProps = {
  label: string;
  onClick?: () => void;
  variant?: 'primary' | 'outline';
  type?: 'button' | 'submit' | 'reset';
  className?: string;
};

export const Button = ({
  label,
  onClick,
  variant = 'primary',
  type = 'button',
  className,
}: ButtonProps) => (
  <button
    type={type}
    onClick={onClick}
    className={clsx(styles.button, styles[variant], className)}
  >
    {label}
  </button>
);
